import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientAddressEntity } from './client-address.entity';
import { ClientEntity } from './client.entity';
import { RouteEntity } from './route.entity';

/**
 * A client (with optional specific address) on a Route's regular client
 * list. Not every RouteClient becomes a TripStop on every Trip — only when
 * the client has an order for that day.
 *
 * Previously `RouteTemplateStopEntity` mapped to `route_template_stop`.
 */
@Entity('route_client')
export class RouteClientEntity extends BaseEntity {
	@Column({ name: 'fk_route__id', type: 'int', unsigned: true })
	public routeId!: number;

	@Column({ name: 'fk_client__id', type: 'int', unsigned: true })
	public clientId!: number;

	@Column({
		name: 'fk_client_address__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public clientAddressId?: number;

	@Column({ name: 'sequence', type: 'int' })
	public sequence!: number;

	@Column({ name: 'notes', type: 'text', nullable: true })
	public notes?: string;

	@Column({ name: 'specialInstructions', type: 'text', nullable: true })
	public specialInstructions?: string;

	/**
	 * Per-stop override for the planned stop duration (minutes). When
	 * set, takes precedence over the per-client value
	 * (`client.tripStopDurationMinutes`) and the tenant default. Use
	 * this when ONE specific stop at the client takes a different time
	 * than the rest of their stops — e.g. a back-dock delivery that
	 * always takes longer than the regular storefront drop. NULL =
	 * cascade to the per-client value or tenant default.
	 */
	@Column({
		name: 'stopDurationMinutes',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public stopDurationMinutes?: number | null;

	@ManyToOne(() => RouteEntity, (route) => route.routeClients)
	@JoinColumn({ name: 'fk_route__id' })
	public fkRoute!: RouteEntity;

	@ManyToOne(() => ClientEntity)
	@JoinColumn({ name: 'fk_client__id' })
	public fkClient!: ClientEntity;

	@ManyToOne(() => ClientAddressEntity)
	@JoinColumn({ name: 'fk_client_address__id' })
	public fkClientAddress?: ClientAddressEntity;
}
